import { Controller } from '@hotwired/stimulus'

// Table-of-contents drawer. Opens/closes the chapter-list <dialog> as a modal
// (so Esc-to-close and the inert backdrop come from the platform). The open/
// close actions are bound from the reader's ☰ button and the drawer's × button.
// Auto-registered by the controllers glob.
export default class extends Controller {
  static targets = ['dialog']

  open() {
    const dialog = this.dialogElement
    if (dialog && typeof dialog.showModal === 'function' && !dialog.open) {
      dialog.showModal()
    }
  }

  close() {
    const dialog = this.dialogElement
    if (dialog && dialog.open) dialog.close()
  }

  get dialogElement() {
    // The button that triggers `open` lives outside the dialog, so resolve the
    // dialog either via the target (when this controller is on the dialog) or
    // by querying the document for the reader's single TOC dialog.
    if (this.hasDialogTarget) return this.dialogTarget
    if (this.element.tagName === 'DIALOG') return this.element
    return document.querySelector('dialog.reader-toc')
  }
}
